import { transaction, observable, computed, toJS } from 'mobx'
import * as defaultConst from '../constants/default_constants'
import * as linkConst from '../constants/link_constants'

export default (BaseClass) => class CReportsState extends BaseClass {
  showReportView (id) {
    this.loadOptions(linkConst.LOAD_OPTIONS.clients)
    this.loadOptions(linkConst.LOAD_OPTIONS.constantsList)
    this.loadOptions(linkConst.LOAD_OPTIONS.contracts)
    this.loadOptions(linkConst.LOAD_OPTIONS.filmcargo_help)
    this.loadOptions(linkConst.LOAD_OPTIONS.films)
    this.loadOptions(linkConst.LOAD_OPTIONS.flyprivate_all_tiers)
    this.loadOptions(linkConst.LOAD_OPTIONS.pprolls)
    this.loadOptions(linkConst.LOAD_OPTIONS.reports)

    this.cv = observable({
      title: this.__(linkConst.LINK_REPORT_VIEW_TITLE),
      description: null,
      fakeID: null,
      items: [],
      loading: false,
      logo: false,
      parameters: null,
      parametersForDownload: {},
      parametersRecord: new Map(),
      purpose: null,
      renderDrop: !id,
      reportid: null,
      reportname: null,
      selection: observable.box([]),
      sortstate: {
        _sortField: null,
        _sortDir: null
      }
    })

    if (id) {
      this.optionsLoadInfo && this.optionsLoadInfo.reports &&
        this.optionsLoadInfo.reports.then(() => {
          const r = this.reports.find(i => i.id === Number(id))
          this.loadReportInfo(id, r ? r.name : null, r).then(() => {
            this.loadParameters(id).then(() => {
              this._ensureAndLoadReport()
            })
          })
        })
    }
  }

  changeReport (id) {
    this.optionsLoadInfo && this.optionsLoadInfo.reports &&
      this.optionsLoadInfo.reports.then(() => {
        const r = this.reports.find(i => i.id === Number(id))
        this.loadReportInfo(id, r ? r.name : null, r).then(() => {
          this.loadParameters(id).then(() => {
            this._ensureAndLoadReport()
          })
        })
      })
  }

  loadWithParams () {
    this._ensureAndLoadReport(true)
  }

  getSavedParameters (id = null) {
    const localParameters = localStorage.getItem(linkConst.REPORTS_STORAGE)
      ? JSON.parse(localStorage.getItem(linkConst.REPORTS_STORAGE))
      : {}
    return id ? localParameters[id] : localParameters
  }

  setSavedParameters (id, parameters = null) {
    const localParameters = this.getSavedParameters() || {}
    if (parameters !== null) {
      localParameters[id] = parameters
    } else {
      delete localParameters[id]
    }
    localStorage.setItem(linkConst.REPORTS_STORAGE, JSON.stringify(localParameters))
  }

  cleanParameters () {
    transaction(() => {
      // clean local storage
      this.setSavedParameters(this.cv.reportid)
      // clean record
      this.cv.parametersRecord.forEach((val, key) => {
        this.cv.parametersRecord.set(key, '')
        delete this.router.queryParams[key]
      })
      this.cv.parametersForDownload = {}
      this.cv.selection = observable.box([])
      this.cv.items = []
    })
  }

  loadParameters (id) {
    return new Promise((resolve) => {
      this.requester.call(`/reports/parameters/${id}`)
        .then(({ data }) => data)
        .then(parameters => {
          this.cv.fakeID = null
          this.cv.parameters = parameters
          this.cv.parametersForDownload = {}
          this.cv.parametersRecord = new Map()
          this.cv.selection = observable.box([])
          this.cv.sortstate = {
            _sortField: null,
            _sortDir: null
          }
          const newParams = {}
          const options = []
          const routerQueryParams = this.router && this.router.queryParams &&
            Object.keys(this.router.queryParams).filter(i => !(defaultConst.MAIN_QUERY_PARAMETERS).includes(i)).length > 0
          const savedParameters = this.getSavedParameters(id)
          const savedAttrParameters = this.getSavedParameters(linkConst.REPORTS_ATTR_PARAMS) || {}

          parameters.forEach(p => {
            if (p.options_attr) {
              options.push(p.options_attr)
            }
            const attrName = p.options_attr || (p.type.toString() + '|' + p.parameter_title.toString())
            const paramName = `${p.id}_param`

            // try load paramValue from different sources
            let paramValue = ''
            if (routerQueryParams) {
              paramValue = this.router.queryParams[paramName] || ''
            } else if (savedParameters) {
              paramValue = savedParameters[paramName] || ''
            } else if (savedAttrParameters) {
              paramValue = savedAttrParameters[attrName] || ''
            }

            // set paramValue if not empty
            if (paramValue && paramValue.length > 0) {
              newParams[paramName] = paramValue
              savedAttrParameters[attrName] = paramValue
            }
            this.cv.parametersRecord.set(paramName, paramValue || '')
          })
          this.router.queryParams = newParams
          this.setSavedParameters(id, newParams)
          this.setSavedParameters(linkConst.REPORTS_ATTR_PARAMS, savedAttrParameters)

          if (options.length > 0) {
            this.loadAllOptions(options).then(() => {
              resolve()
            })
          } else {
            resolve()
          }
        })
    })
  }

  _ensureAndLoadReport (withParams) {
    const id = this.cv.reportid
    const name = this.cv.reportname

    if (id && name) {
      if (this.cv.parameters && this.cv.parameters.length > 0) {
        if (withParams) {
          this.loadReportData(id, name, this.cv.parametersRecord)
        }
      } else {
        this.loadReportData(id, name)
      }
    }
  }

  loadReportInfo (id, name, r) {
    return new Promise((resolve) => {
      transaction(() => {
        this.cv.reportname = name
        this.cv.reportid = id
        this.cv.description = r && Object.prototype.hasOwnProperty.call(r, 'description') && r.description
        this.cv.purpose = r && Object.prototype.hasOwnProperty.call(r, 'purpose') && r.purpose
        this.cv.items = []
        resolve()
      })
    })
  }

  loadReportData (id, name, parameters) {
    const savedAttrParameters = this.getSavedParameters(linkConst.REPORTS_ATTR_PARAMS) || {}
    this.router.queryParams = {}

    parameters && Object.entries(toJS(parameters)).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v.length > 0) {
        this.router.queryParams[k] = v
        // find and save 'attr' parametrs to the storage
        this.cv.parameters && this.cv.parameters.forEach(p => {
          const kID = k.substring(0, k.indexOf('_'))
          const attrName = p.options_attr || (p.type.toString() + '|' + p.parameter_title.toString())
          if (p.id && parseInt(p.id) === parseInt(kID)) {
            savedAttrParameters[attrName] = v
          }
        })
        // -
      }
    })
    this.setSavedParameters(id, { ...this.router.queryParams })
    this.setSavedParameters(linkConst.REPORTS_ATTR_PARAMS, savedAttrParameters)

    this.cv.loading = true
    this.cv.selection = observable.box([])
    this.requester.call(`/reporting/load/${id}`, 'post', { parameters })
      .then((result) => {
        transaction(() => {
          this.cv.loading = false
          this.cv.parametersForDownload = toJS(parameters)
          this.cv.items = result.data
        })
      })
      .catch(this.onRequesterError.bind(this))
  }

  reportsForEntitities (entities) {
    return this.reports.filter(i => {
      return entities.indexOf(i.entity_filter) >= 0 &&
        this.hasRight(i.entity_filter) &&
        i.type === 'report'
    })
  }

  @observable reports = []

  @computed get availableReports () {
    return this.reports.filter(i => {
      return (this.hasRight(i.entity_filter) || !i.entity_filter) && ['report', 'extern'].includes(i.type)
    })
  }

  sortReport (attr, dir) {
    const sortFields = this.cv.sortstate._sortField ? this.cv.sortstate._sortField.split(',') : []
    const sortDirs = this.cv.sortstate._sortDir ? this.cv.sortstate._sortDir.split(',') : []
    const sortStateIdx = sortFields.indexOf(attr)
    this.cv.selection = observable.box([])

    if (sortStateIdx >= 0 && dir) {
      sortDirs[sortStateIdx] = dir
    } else if (sortStateIdx >= 0 && dir === null) {
      sortFields.splice(sortStateIdx, 1)
      sortDirs.splice(sortStateIdx, 1)
    } else {
      sortFields.push(attr)
      sortDirs.push(dir)
    }

    const _cmp = (a, b) => {
      for (const fieldId in sortFields) {
        const field = sortFields[fieldId]
        const fieldSortDir = sortDirs[fieldId]
        const sa = '' + a[field]
        const sb = '' + b[field]
        const localCopared = (fieldSortDir === 'ASC') ? sa.localeCompare(sb) : sb.localeCompare(sa)

        if (localCopared === 0) { continue }

        return localCopared
      }
    }

    transaction(() => {
      this.cv.items.replace(this.cv.items.sort(_cmp))
      this.cv.sortstate._sortField = sortFields.join(',')
      this.cv.sortstate._sortDir = sortDirs.join(',')
    })
  }

  perPageOptions = [5, 10, 15, 20, 50, 100, 1000]

  setPerPage (num) {
    this.router.queryParams = this.router.queryParams || {}
    this.router.queryParams._page = 1
    this.router.queryParams._perPage = num
    this.setUserPreferences && this.setUserPreferences('cargo_perPage', num)
    delete this.router.queryParams._allPages
    this.setUserPreferences && this.setUserPreferences('cargo_allPages', '')
    this.cv.selection = observable.box([])
  }

  updatePage (page) {
    this.selection = []
    this.selectionAll = false
    this.router.queryParams = this.router.queryParams || {}
    this.router.queryParams._page = page
    delete this.router.queryParams._allPages
    this.cv.selection = observable.box([])
  }

  showAllPages () {
    this.router.queryParams = this.router.queryParams || {}
    this.router.queryParams._allPages = true
    this.setUserPreferences && this.setUserPreferences('cargo_allPages', true)
    delete this.router.queryParams._page
    delete this.router.queryParams._perPage
    this.cv.selection = observable.box([])
  }
}
